import { ActionReducer, MetaReducer } from '@ngrx/store';
import { utilLocalStorageReducer } from '@medlogic/shared/utils';
import { initialStateHorario } from './horarios.reducer';


const KEY = 'MEDLOGIC_HORARIO_STATE';

// Includes the action types that must be persisted.
const PERSISTED_ACTIONS: string[] = [

].map(m => m.type.toString());

export function localStorageReducer(reducer: ActionReducer<any>): ActionReducer<any> {
  return utilLocalStorageReducer(reducer, PERSISTED_ACTIONS, KEY, initialStateHorario);
}

export const metaReducers: MetaReducer<any>[] = [localStorageReducer];
